/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { useGetCustomersQuery } from "~/generated/graphql";

export function useGetCustomers({
  client,
}: {
  client: ApolloClient<NormalizedCacheObject>;
}) {
  const { data, loading, error, refetch } = useGetCustomersQuery({
    client: client,
  });

  return { customers: data?.customersList, loading, error, refetch } as const;
}
